import React, { useState, useEffect } from "react";

const NotificationTest = () => {
  const [permission, setPermission] = useState("default");
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    // Check if notifications are supported
    setIsSupported("Notification" in window);

    // Get current permission status
    if ("Notification" in window) {
      setPermission(Notification.permission);
    }
  }, []);

  const requestPermission = async () => {
    try {
      const result = await Notification.requestPermission();
      setPermission(result);
    } catch (error) {
      console.error("Error requesting notification permission:", error);
    }
  };

  const sendTestNotification = async () => {
    if (!("Notification" in window)) {
      console.error("Notifications not supported");
      return;
    }

    if (Notification.permission !== "granted") {
      console.error("Notification permission not granted");
      return;
    }

    try {
      const registration = await navigator.serviceWorker.ready;
      await registration.showNotification("Test Notification", {
        body: "This is a test notification from 99 Darts",
        icon: "/icons/icon-192.png",
        badge: "/icons/icon-192.png",
        vibrate: [200, 100, 200],
        tag: "test-notification",
      });
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };

  if (!isSupported) {
    return (
      <div className="p-4 bg-red-100 text-red-700 rounded-lg">
        Notifications are not supported in your browser
      </div>
    );
  }

  return (
    <div className="p-4 bg-secondary/80 backdrop-blur-sm rounded-lg shadow-lg border border-primary/20">
      <h2 className="text-xl font-semibold text-white mb-4">
        Notification Test
      </h2>

      <div className="space-y-4">
        <div>
          <p className="text-white/80 mb-2">
            Current permission status: {permission}
          </p>
          {permission !== "granted" && (
            <button
              onClick={requestPermission}
              className="bg-test hover:bg-test/90 text-primary px-4 py-2 rounded-lg transition-colors"
            >
              Request Permission
            </button>
          )}
        </div>

        {permission === "granted" && (
          <button
            onClick={sendTestNotification}
            className="bg-test hover:bg-test/90 text-primary px-4 py-2 rounded-lg transition-colors"
          >
            Send Test Notification
          </button>
        )}
      </div>
    </div>
  );
};

export default NotificationTest;
